<template>
  <div class="container shadow">
    <div class="container shadow">
      <div class="row">
        <form @submit.prevent="createClient" class="p-4">
          <h4 class="text-center">Create a new client</h4>
          <div class="col-sm-12 row">
            <div class="col-sm-6 mb-4" role="alert">
              <input
                class="form-control mb-2"
                id="name"
                type="text"
                placeholder="name"
                v-model="user.name"
              />

              <input
                class="form-control mb-2"
                type="text"
                placeholder="email"
                v-model="user.email"
              />

              <input
                class="form-control mb-2"
                type="text"
                placeholder="Company Name"
                v-model="user.company_name"
              />
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-secondary btn-sm">
                Create Client
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <form @submit.prevent="upload" class="bg-light p-4 card mb-4">
      <div class="col-sm-12">
        <div class="alert alert-primary" role="alert">
          <h4>Send an invoice for payment to a customer</h4>
        </div>
      </div>

      <div class="col-sm-12 mt-2 bg-dark shadow card">
        <div class="form-row">
          <div class="form-group col-md-6">
            <div class="form-group">
              <label for="chooseClient"
                ><b class="text-white">
                  <span class="badge badge-pill badge-danger">*</span> Select
                  Client</b
                >
              </label>
              <select
                class="form-control"
                id="chooseClient"
                v-model="product.contact"
              >
                <option
                  v-for="contact in contacts"
                  :value="contact.id"
                  :key="contact.id"
                >
                  {{ contact.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="chooseClient"
                ><b class="text-white">
                  <span class="badge badge-pill badge-danger">*</span> Select a
                  Product</b
                >
              </label>
              <select
                class="form-control"
                id="chooseClient"
                v-model="product.item"
              >
                <option
                  v-for="product in products.data"
                  :value="product.id"
                  :key="product.id"
                >
                  {{ product.unit_amount }}
                </option>
              </select>
            </div>

            <label for="inputEmail4"
              ><b class="text-white">
                <span class="badge badge-pill badge-danger">*</span> Name</b
              >
            </label>

            <input
              type="text"
              class="form-control"
              id="inputEmail4"
              v-model="product.name"
              placeholder="Plan reference, Clothes, Software"
            />

            <br />
            <label for="inputAddress"
              ><b class="text-white">
                <span class="badge badge-pill badge-danger">*</span> Rate</b
              ></label
            >
            <input
              type="text"
              class="form-control"
              id="inputEmail4"
              v-model="product.rate"
              placeholder="0.00 US$ / mes"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleFormControlTextarea1"
              ><b class="text-white">
                <span class="badge badge-pill badge-danger">*</span>
                Description</b
              ></label
            >
            <textarea
              class="form-control"
              id="exampleFormControlTextarea1"
              placeholder="A little description for your product"
              v-model="product.description"
              rows="5"
            >
            </textarea>
          </div>
        </div>

        <div class="form-group">
          <button type="submit" class="btn btn-info btn-sm">
            Send Invoice for Payment
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      product: {
        item: "",
        name: "",
        rate: "",
        contact: "",
        description: ""
      },
      user: {
        name: "",
        email: "",
        company_name: ""
      },
      contacts: "",
      products: []
    };
  },

  created() {
    window.axios.get("api/client").then(response => {
      this.contacts = response.data;
    }),
      this.getProducts();
  },

  methods: {
    upload() {
      window.axios.post("/api/sendInvoice", this.product).then(res => {
        this.product = [];
        console.log(res.data);
      });
    },

    createClient() {
      window.axios.post("/api/createClient", this.user).then(() => {
        this.user = {};
      });
    },

    getProducts() {
      window.axios.get("/api/getProducts", this.products).then(response => {
        this.products = response.data;
      });
    }
  }
};
</script>
<style scoped>
.classActive {
  background-color: rgb(15, 15, 15);
  border: 0;
}
</style>
